import styled from 'styled-components/macro'
import { motion } from 'framer-motion'
 
export const CaracContainer = styled(motion.div)`
    width: 100%;
    margin: 6rem auto 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    @media screen and (max-width: 650px) {
        margin-top: 3rem;
    }
`

export const CaracInner = styled.div`
    width: 90%;
    margin: 0 auto;
    display: flex;
    justify-content: center;

    @media screen and (max-width: 650px) {
        flex-direction: column;
        align-items: center;
    }
`

export const CaracImageContainer = styled(motion.div)`
    width: 50%;
    display: flex;
    justify-content: center;

    @media screen and (max-width: 650px) {
        width: 90%;
        align-self: center;
        margin-bottom: 2rem;
    }
`

export const CaracImageInner = styled.div`
    border-radius: 50%;
    height: 15rem;
    width: 15rem;
    overflow: hidden;
    border: 2px solid black;
    background-color: white;
    display: flex;
    justify-content: center;

    @media screen and (max-width: 650px) {
        flex-direction: column;
        height: 10rem;
        width: 10rem;
    }
`


export const CaracImage = styled.img`
    object-fit: contain;
`

export const CaracDetailsContainer = styled.div`
    width: 50%;
    display: flex;
    justify-content: center;
    position: relative;

    @media screen and (max-width: 650px) {
        width: 85%;
    }
`